import type { TrackedItemInput } from "../types";
import { units } from "../types/receipt";

export function checkedTrackedItems(
  items: TrackedItemInput[],
): TrackedItemInput[] {
  if (items.length > 100)
    throw new Error("Track at most 100 items per expense.");
  const seen = new Set<string>();
  return items.map((item) => {
    const value = { ...item, group: item.group.trim() || item.name.trim() };
    if (!/^\d+(\.\d{1,2})?$/.test(value.total) || Number(value.total) < 0)
      throw new Error(`Price for ${value.name || "item"} must be zero or a positive numeric total with at most two decimals. Ask the user if it is missing.`);
    if (value.unit && !units.includes(value.unit as (typeof units)[number]))
      throw new Error(`Unsupported unit for ${value.name}: use each, dozen, sheet, roll, g, kg, ml or l.`);
    if ((value.measure || value.unit) && (!value.measure || !value.unit || !Number.isFinite(Number(value.measure)) || Number(value.measure) <= 0))
      throw new Error(`For ${value.name}, provide both a positive numeric comparison quantity and a supported unit, or leave both empty. Pack description is optional.`);
    if (
      !value.id ||
      seen.has(value.id) ||
      !value.name.trim() ||
      value.name.length > 160 ||
      value.group.length > 80 ||
      !/^\d+(\.\d{1,2})?$/.test(value.total) ||
      Number(value.total) < 0 ||
      Number(value.total) > 10000000 ||
      ((value.measure || value.unit) &&
        (!Number.isFinite(Number(value.measure)) ||
          Number(value.measure) <= 0 ||
          !value.unit ||
          !units.includes(value.unit as (typeof units)[number])))
    )
      throw new Error(
        `Check the name, price and comparison quantity for ${value.name || "this item"} before saving.`,
      );
    seen.add(value.id);
    return value;
  });
}
